import { useCallback } from "react";
import { onEnterOrSpaceKeyDown } from "Utils";

// This is required to memoize the callback funtion and args passed to onEnterOrSpaceKeyDown and to keep the stable reference for function returned.
const useKeyDownWrapper = (callback, args = {}) => {
  return useCallback(
    event => {
      onEnterOrSpaceKeyDown(event, () => callback(args));
    },
    [callback, args] // Dependencies to re-memoize the function when callback or args change
  );
};

export { useKeyDownWrapper };
